// extracted by mini-css-extract-plugin
export default {"createTicketButton":"default_createTicketButton__2Z1NE","createTicketButtonIcon":"default_createTicketButtonIcon__CRKcX"};